module.exports = __webpack_public_path__ + "static/kesem-2-d7732749acdc4e2628de2b7bee42b9a9.jpg";